module.exports = __webpack_public_path__ + "static/media/celebration-final.f29d2e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/celebration-final.svg
// module id = 1384
// module chunks = 0